// Import here Polyfills if needed. Recommended core-js (npm i -D core-js)
import 'core-js/fn/array/find'
import 'core-js/fn/promise'
import 'core-js/fn/object/assign'
// ...

import { JwtUser } from './Models/JwtUser'
import { ACLPermission, ACLPermissionValues } from './Models/Permissions'
import { AuthotizationHandler } from './AuthorizationHandler'
import { resolve } from 'path'
import { rejects } from 'assert'
import { PortalUrl } from './Models/Environments'
import { ECANCELED } from 'constants'
export { ACLPermission } from './Models/Permissions'
import { ApprovalHandler } from './ApprovalHandler'
import { PortalUrlProvider } from './PortalUrlProvider'
export { ApprovalHandler } from './ApprovalHandler'
export { PortalUrlProvider } from './PortalUrlProvider'
export { AuthotizationHandler } from './AuthorizationHandler'
/**
 * Common Logon Portal Library.
 */
export class Helper {
  // static  PortalUrl: string;
  private _authHandler: AuthotizationHandler
  private _env: string

  
  constructor(environment: string, baseHref: string = '') {
    this._authHandler = new AuthotizationHandler(baseHref)
    if(environment){
      this._env = environment;
    }else{
      this._env = 'prod';
    }
    // this.XHRListener();
  }

  public LogOut(redirectTo?: string): void {
    const portalUrl = this._authHandler._getPortalUrlForEnvironment(this._env)
    this._authHandler.deleteAuthorizationCookie();
    this._authHandler.DeleteAutorizationInfo()
    if (redirectTo) {
      window.location.href = `${portalUrl}/ecportal/logout?redirectTo=${redirectTo}`
    } else {
      window.location.href = portalUrl + '/ecportal/logout'
    }
    /*if(Environment){
      const portalUrl = this._authHandler._getPortalUrlForEnvironment(Environment);
      this._authHandler.DeleteAutorizationInfo()
      if (redirectTo) {
        window.location.href = `${portalUrl}/logout?redirectTo=${redirectTo}`
      } else {
        window.location.href = portalUrl + '/logout'
      }
      return new Promise<any>((resolve, reject)=>{
        resolve(true);
      });
    }else{
      const me = this
      return this.User().then(function(user) {
        const portalUrl = me._authHandler.getPortalUrl(user)
        me._authHandler.DeleteAutorizationInfo()
        if (redirectTo) {
          window.location.href = `${portalUrl}/logout?redirectTo=${redirectTo}`
        } else {
          window.location.href = portalUrl + '/logout'
        }
        return true
      });
    }*/
  }
  /*public LogOut(Environment: string,redirectTo?: string): void {
    const portalUrl = this._authHandler._getPortalUrlForEnvironment(Environment);
      this._authHandler.DeleteAutorizationInfo()
      if (redirectTo) {
        window.location.href = `${portalUrl}/logout?redirectTo=${redirectTo}`
      } else {
        window.location.href = portalUrl + '/logout'
      }
  }*/
  public User(callback?: (user?: JwtUser) => void): Promise<JwtUser> {
    return this._authHandler.GetUserInfo(callback)
  }

  public UserIsInRole(RoleName: string, callback?: (result: boolean) => void): Promise<boolean> {
    let p = new Promise<boolean>((resolve, reject) => {
      this.User()
        .then(
          user => {
            const userISInRole = user.Roles
              ? user.Roles.some(r => r.toLocaleLowerCase() === RoleName.toLocaleLowerCase())
              : false
            if (callback) {
              callback(userISInRole)
            }
            resolve(userISInRole)
          },
          reject => {
            if (callback) {
              callback(false)
            }
            resolve(false)
          }
        )
        .catch(reason => {
          if (callback) {
            callback(false)
          }
          resolve(false)
        })
    })

    return p
  }

  public UserCanOn(
    SecurableName: string,
    Permission: number,
    callback?: (result: boolean) => void
  ): Promise<boolean> {
    let p = new Promise<boolean>((resolve, reject) => {
      let userCan = false
      this.User()
        .then(
          user => {
            const efectivePermission = user.EfectivePermissions
              ? user.EfectivePermissions.find(
                  sm => sm.Key.toLocaleLowerCase() === SecurableName.toLocaleLowerCase()
                )
              : null
            if (efectivePermission) {
              const n = Permission * 1
              userCan = (efectivePermission.Value & n) === n
            }
            if (callback) {
              callback(userCan)
            }
            resolve(userCan)
          },
          reject => {
            if (callback) {
              callback(false)
            }
            resolve(false)
          }
        )
        .catch(reason => {
          if (callback) {
            callback(false)
          }
          resolve(false)
        })
    })

    return p
  }
  public SignIn(redirectTo: string = ''): void {
    this._authHandler.SignIn(redirectTo)
  }
  /**
   * @private-doc
   */
  public static _HandleRedirect(url: string) {
    window.location.href = this.updateQueryStringParameter(url, 'redirectTo', window.location.href)
  }
  private static updateQueryStringParameter(uri: string, key: string, value: string): string {
    const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
    const separator = uri.indexOf('?') !== -1 ? '&' : '?'
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + value + '$2')
    } else {
      return uri + separator + key + '=' + value
    }
  }
  public EnsureApproval(): Promise<boolean> {
    return new Promise<boolean>(function(resolve, reject) {
      ApprovalHandler.approvalResolver = resolve
      const approvalHandler = new ApprovalHandler()
      const authHandler = new AuthotizationHandler()
      authHandler.GetUserInfo(function(user?: JwtUser) {
        if (user) {
          PortalUrlProvider.PortalUrl = authHandler.getPortalUrl(user, true)
          approvalHandler
            .EnsureBaseUrl()
            .then(function() {
              approvalHandler.toggleModal()
            })
            .catch(reason => reject(false))
        } else {
          reject(false)
        }
      })
    })
  }

  // public get permissions(): ACLPermission {
  //   return {
  //     VIEW: ACLPermission.VIEW,

  //   };
  // }
}
;(function() {
  let messageEventIsSetted = false
  const approvalHandler = new ApprovalHandler()
  const authHandler = new AuthotizationHandler()
  function windowOnClick(event: any) {
    if (event.target === ApprovalHandler.htmlModalElement) {
      if (ApprovalHandler.approvalResolver) {
        ApprovalHandler.approvalResolver(false)
      }
      approvalHandler.toggleModal()
    }
  }
  function receiveApprovalMessage(message: MessageEvent) {
    const l = document.createElement('a')
    l.href = PortalUrlProvider.PortalUrl
    /*if(message.origin !== l.origin){
     return;
   }*/
    if (message.data && message.data.status && message.data.status === 'done') {
      approvalHandler.toggleModal()
      if (ApprovalHandler.approvalResolver) {
        ApprovalHandler.approvalResolver(true)
      }
    }
  }

  window.addEventListener('click', windowOnClick)
  if (messageEventIsSetted === false) {
    messageEventIsSetted = true
    if (window.addEventListener) {
      window.addEventListener('message', receiveApprovalMessage)
    } else {
      ;(window as any).attachEvent('onmessage', receiveApprovalMessage)
    }
  }
  /*const setRequestHeader = XMLHttpRequest.prototype.setRequestHeader
  XMLHttpRequest.prototype.setRequestHeader = function(name:string, value:string){
    if(!(this as any).headers){
      (this as any).headers = [];
    }
    (this as any).headers[name]=value;
    if(!(this as any).containsKey){
      const me = this;
      (this as any).containsKey = function(key:string){
        return (this as any).headers.indexOf(key) !== -1
      }
    }
    setRequestHeader(name,value);
  }*/
  const send = XMLHttpRequest.prototype.send
  XMLHttpRequest.prototype.send = function() {
    this.setRequestHeader('X-Instrumented-WithEC', '1')

    this.addEventListener('load', function() {
      if ((this.status === 401 || this.status === 403) && this.readyState === 4) {
        if (this.getResponseHeader('redirectTo')) {
          const redirectUrl = this.getResponseHeader('redirectTo')
          if (this.status === 401 && (redirectUrl as string).indexOf('approve') !== -1) {
            // if(!PortalUrlProvider.PortalUrl){
            authHandler.GetUserInfo(function(user?: JwtUser) {
              if (user) {
                PortalUrlProvider.PortalUrl = authHandler.getPortalUrl(user, true)
                approvalHandler.toggleModal()
                const iframe = document.getElementById('ec-modal-approval-iframe') as any
                iframe.src = PortalUrlProvider.PortalUrl + '/approve/embedded'
              }
            })
            /* } else {
                  iframe.src=PortalUrlProvider.PortalUrl+'/approve/embedded';
                   approvalHandler.toggleModal();
                }*/
            // attach to message event
            /*if(messageEventIsSetted===false){
                messageEventIsSetted=true;
                if (window.addEventListener) {
                  window.addEventListener('message', receiveApprovalMessage);
                } else {
                   (window as any).attachEvent('onmessage', receiveApprovalMessage);
                }
               }*/
          } else {
            Helper._HandleRedirect(redirectUrl || '')
          }
        }
      }
    })
    return send.apply(this, arguments as any)
  }
  if (window.fetch) {
    const { fetch: originalFetch } = window
    window.fetch = async (...args) => {
      let [resource, config] = args
      if (!config) config = {}
      if (!config.headers) {
        config.headers = new Headers()
      }
      if ((config.headers as any).append) {
        ;(config.headers as any).append('X-Instrumented-WithEC', '1')
      } else {
        config.headers = { ...config.headers, 'X-Instrumented-WithEC': '1' }
      }

      let response = await originalFetch(resource, config)
      if (response.status === 401 || response.status === 403) {
        if (response.headers.has('redirectTo')) {
          const redirectUrl = response.headers.get('redirectTo')
          if (response.status === 401 && (redirectUrl as string).indexOf('approve') !== -1) {
            authHandler.GetUserInfo(function(user?: JwtUser) {
              if (user) {
                PortalUrlProvider.PortalUrl = authHandler.getPortalUrl(user, true)
                approvalHandler.toggleModal()
                const iframe = document.getElementById('ec-modal-approval-iframe') as any
                iframe.src = PortalUrlProvider.PortalUrl + '/approve/embedded'
              }
            })
          } else {
            Helper._HandleRedirect(redirectUrl || '')
          }
        }
      }

      return response
    }
  }
})()
